import { createContext, useContext, useEffect, useState } from "react";

const Ctx = createContext(null);
const KEY = "islasol_wishlist";

export const WishlistProvider = ({ children }) => {
  const [ids, setIds] = useState(() => { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; } });
  useEffect(() => { localStorage.setItem(KEY, JSON.stringify(ids)); }, [ids]);
  const toggle = (id) => setIds((l) => (l.includes(id) ? l.filter((x) => x !== id) : [...l, id]));
  const has = (id) => ids.includes(id);
  const addMany = (list) => setIds((l) => [...new Set([...l, ...list])]);
  return <Ctx.Provider value={{ ids, toggle, has, addMany, clear: () => setIds([]) }}>{children}</Ctx.Provider>;
};

export const useWishlist = () => useContext(Ctx);
